module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-base', {
    staticClass: "fzg-qrcode-modal",
    on: {
      "hide-modal": _vm.hideModal
    }
  }, [_c('template', {
    slot: "header"
  }), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": require("../../assets/img2/mobile/common/qr_01.jpg")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": "https://static-image.xfz.cn/1697974278002/qr_m.jpg",
      "width": "198px"
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45423653"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/QrcodeModal.vue
// module id = 223
// module chunks = 0